/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { Checkbox } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { sha256 } from 'js-sha256';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { FaPlay } from 'react-icons/fa';
import { Md360 } from "react-icons/md";
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { sendUser } from '../../../../../../services/properties';
import { formatarDataEntrega, formatAutomaticPropertyRooms, interesseInicial, NumeroFormatado, rotulosHifenBreadcrumb, toPrice, trackEvent } from '../../../../../../utils/FunctionsGlobals';
import { trackMetaEvent, genMetaEventId, resolvePixelId, sendMetaCapiEvent, metaPrecoParams } from '../../../../../../utils/metaPixel';
import { resolveSiteWhatsAppUrl } from '../../../../../../utils/site2524WhatsApp';
import { whatsParaImobiliaria } from '../../../../../../utils/whatsappImobiliaria';
import { buildCanonical } from '../../../../../../utils/url';

import { Swiper, SwiperSlide } from 'swiper/react';

// utils
import { BsEyeFill } from 'react-icons/bs';
import HistoryComponent from '../../../../../../components/history/HistoryComponent';
import { AppPhoneInput } from '../../../../../../components/input_phone/AppPhoneInput';
import { trackLead } from '../../../../../../components/whatsAppButton/WhatsAppButton';
import Botoes from '../botoes/Botoes';
import Compartilhar from '../botoes/Compartilhar';
import { canShowPropertyAddress, formatPropertyAddress } from '../../../../../../utils/propertyAddress';
import DecorarPhotoPill from '../../../../../../components/pieces/decorador/DecorarPhotoPill';
import DecorarHeroButton from '../../../../../../components/pieces/decorador/DecorarHeroButton';
import DecorarBadge from '../../../../../../components/pieces/decorador/DecorarBadge';
import { useDecoradorStatus } from '../../../../../../components/pieces/decorador/decoradorBus';
import { isFotoDecorada, podeDecorarFoto } from '../../../../../../components/pieces/decorador/decoradorFotos';
import { getWatermarkImageSrc, WatermarkFallbackImage } from '../WatermarkFallbackImage';
import { corTituloImovel } from '../../../../../../utils/topoContato';
import PrecoMoeda from '../../../../../../components/pieces/idiomas/PrecoMoeda';
import { temSeletorIdiomas } from '../../../../../../utils/moedaSite';
import { finalidadeAceiteForm } from '../../../../../../utils/textoAceiteForm';
import { ehModeloHorizonte } from '../../../../../../components/pieces/horizonte/horizonte';
import { ehModeloAurora } from '../../../../../../components/pieces/aurora/aurora';
import { ehModeloPanorama } from '../../../../../../components/pieces/panorama/panorama';
import { ehModeloLarissa } from '../../../../../../components/pieces/larissa/larissa';
import { ehModeloMetropole } from '../../../../../../components/pieces/metropole/metropole';
import { ehModeloInternacional } from '../../../../../../components/pieces/internacional/internacional';
import styles from './GalleryPiecesProperties.module.css';
import { temTelefonePorOperacao, telefoneOperacao } from '../../../../../../utils/telefoneOperacao';

const GalleryPiecesProperties3: React.FC<{

    gallery: Array<any>;
    site: any;
    detailsProperties: any;
    orderGallery: any;
    setOrderGallery: any;
    setZoomPhoto: any;
    origin?: any;
    codsite?: any;
    setOpenMapa?: any;
    setOpenStreet?: any;
    setOpenOption?: any;
    openOption?: any;
    favorito?: any;
    setFavorito?: any;
    managerActual?: any;
}> = ({
    gallery,
    site,
    detailsProperties,
    orderGallery,
    setOrderGallery,
    origin,
    codsite,
    setOpenMapa,
    setOpenStreet,
    setZoomPhoto: _setZoomPhoto,
    setOpenOption,
    openOption,
    favorito,
    setFavorito,
    managerActual
}) => {
    // Horizonte (topo 11): a skin vem do CSS gateado por [data-modelo='horizonte']; aqui só saem as
    // cores inline do painel "Acesso completo" (o CSS não as vence sem !important).
    const horizonte = ehModeloHorizonte(site);
    // Aurora (topo 10) / Panorama (topo 13) / Larissa (topo 14): a MESMA troca, com a skin em
    // [data-modelo='aurora'|'panorama'|'larissa'].
    // Metrópole (topo 15): idem, skin em [data-modelo='metropole'].
    const modeloNovo = horizonte || ehModeloAurora(site) || ehModeloPanorama(site) || ehModeloLarissa(site) || ehModeloMetropole(site) || ehModeloInternacional(site) || Number(site?.modelo_topo) === 17 || Number(site?.modelo_topo) === 18;
    // Larissa: preço ROTULADO como no card ("Venda" pequeno em cima, moeda + valor embaixo); fora dele o
    // MESMO texto de sempre ("Venda: R$"). Com conversor de moeda o símbolo já vem no PrecoMoeda.
    // Internacional (topo 16): o mesmo preço ROTULADO do Larissa (rótulo pequeno em cima, valor embaixo).
    // Norte (topo 17) e Campo (topo 18): idem.
    const larissa = ehModeloLarissa(site) || ehModeloInternacional(site) || Number(site?.modelo_topo) === 17 || Number(site?.modelo_topo) === 18;
    // Metrópole (topo 15): o MESMO preço rotulado (rótulo 12px cinza em cima, valor 24px/700 embaixo).
    const precoRotulado = larissa || ehModeloMetropole(site);
    const rotuloPreco = (rotulo: string, legado: React.ReactNode): React.ReactNode => precoRotulado
        ? <><span className={styles.rotulo_preco}>{rotulo}</span>{conversor ? null : simboloImovel}</>
        : legado;
    // useState
    const router = useRouter();
    const { ativo: decoradorAtivo, v2: decoradorV2 } = useDecoradorStatus();
    const { utm_campaign } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const { verFts } = router.query;
    const { verfts } = router.query;
    const { agenciador } = router.query;
    const [animationPhoto, setAnimationPhoto] = useState<number>(-1);
    const [name, setName] = useState('');
    const [telephone, setTelephone] = useState('');
    const [email, setEmail] = useState('');
    const [existUser, setExistUser] = useState<any>(null);
    const [acceptPolitic, setAcceptPolitic] = useState(false);
    const [processando, setProcessando] = useState(false);
    const [interesse, setInteresse] = useState<any>(interesseInicial(detailsProperties, site));
    const propertyTitle = String(detailsProperties?.titulo || '').trim();
    const hasPropertyTitle = propertyTitle.length > 0 && propertyTitle.toLowerCase() !== 'null';
    // Unidade do TERRENO (tbl_imovel.AreaTipo) — no CRM o campo se chama "Tipo de medida
    // (terreno)"; área privativa/total/útil são SEMPRE m². Ticket #1070.
    const rawAreaTipo = String(detailsProperties?.area_tipo || '').trim();
    const areaTipo = rawAreaTipo && rawAreaTipo.toLowerCase() !== 'null' ? rawAreaTipo : 'm²';
    const stylo: React.CSSProperties = {
        '--swiper-navigation-color': site?.cor2 || 'gray',
        '--swiper-pagination-color': site?.cor2 || 'gray',
        '--swiper-pagination-bullet-inactive-color': site?.cor2 || 'gray',
        '--swiper-pagination-bullet-inactive-opacity': '0.5',
        '--swiper-pagination-bullet-size': '15px',
        'background': site?.cor5
    } as React.CSSProperties;
    // const [active, setActive] = useState(false);

    const selectTransacao = async () => {
        if(interesse == "Venda"){
            setInteresse("Aluguel")
        } else {
            setInteresse("Venda")
        }
    }

    const initialFlow: any = [
        'home',
        'imóveis', `${router.query.model || "-"}`,`${router.query.city || "-"}`,`${router.query.district || "-"}`,`${site?.exibir_empreendimento ? router.query.company || "-" : '-'}`,`${router.query.type || "-"}`,`${router.query.code || "-"}`
    ];
    // cs2588: nome real no lugar do segmento com hífen (gate utils/hifenUrl; fora dele, vazio)
    const rotulosHistorico = rotulosHifenBreadcrumb(detailsProperties, site);

    const calcularTotal = (precoLocacao?: number, precoCondominio?: number, precoIptu?: number): number => {
        const locacao = precoLocacao || 0;
        const condominio = precoCondominio || 0;
        const iptu = precoIptu || 0;

        return locacao + condominio + iptu;
    };
    // H1 na cor da logo (utils/topoContato, cs2639); undefined = cor do CSS, sem atributo style
    const corTitulo = corTituloImovel(site);
    const estiloTitulo = corTitulo ? { color: corTitulo } : undefined;
    const isSite1791 = Number(site?.id) === 1791;
    const isSite2537 = Number(site?.id) === 2537;
    const isSite2504 = Number(site?.id) === 2504;
    const isSite2507 = Number(site?.id) === 2507;
    const isSite2551 = Number(site?.id) === 2551;
    const shouldBlockPhotos =
        Boolean(Number(site?.bloquear_fotos) || detailsProperties?.bloquear_fotos) &&
        !(Number(detailsProperties?.aluguel) > 0 && Number(site?.libera_fts_aluguel));
    const site2551CondominioPrefix = isSite2551 ? '+/- ' : '';
    // cs2504 (05/10): preço na moeda escolhida no topo (utils/moedaSite). Fora do gate, o texto de sempre.
    // gate = seletor de idiomas ligado (preço em notranslate); PrecoMoeda só converte com o conversor (21/10)
    const conversor = temSeletorIdiomas(site);
    const simboloImovel = detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo;
    const site2551CondominioAddendum = isSite2551 ? ' + CONSUMOS/ENGARGOS' : '';
    const hasVenda = Number(detailsProperties?.venda) > 0 || detailsProperties?.venda === true;
    const hasAluguel = Number(detailsProperties?.aluguel) > 0 || detailsProperties?.aluguel === true;
    const propertyTransaction: 'venda' | 'locacao' = hasAluguel && !hasVenda ? 'locacao' : 'venda';

    // Link do imóvel nos hrefs do WhatsApp do topo: calculado IGUAL no SSR e no cliente (host da requisição =
    // `origin`/prodOrigin + asPath, mesmo buildCanonical do canonical) — o HTML do servidor já sai com o link e o
    // href não diverge na hidratação. Antes vinha do window ('' no SSR → "Link:" vazio; INC-0283). Vale p/ todos.
    const propertyUrl = buildCanonical(origin, router.asPath).replaceAll("%20", "-").replaceAll(" ", "-");
    const cleanPhone = (phone?: string) => (phone || '').replace(/\D/g, '');
    const resolveWhatsappPhone = (
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = propertyTransaction
    ) => {
        if (isSite1791) {
            if (transaction === 'locacao' && hasAluguel && !hasVenda) {
                return '555184010353';
            }
            return '5551984012364';
        }
        // SD-0049 (gate cs2532): número por operação vindo do cadastro (tel1 venda / tel3 locação)
        if (temTelefonePorOperacao(site)) {
            return cleanPhone(telefoneOperacao(site, transaction));
        }

        return cleanPhone(fallbackPhone);
    };
    const buildWhatsappUrl = (
        message: string,
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = propertyTransaction
    ) => {
        const phone = resolveWhatsappPhone(fallbackPhone, transaction);
        if (!phone) return '#';

        const prefix = isSite1791 || managerActual?.internacional ? '' : '55';
        return resolveSiteWhatsAppUrl(site, `https://api.whatsapp.com/send?phone=${prefix}${phone}&text=${message}`);
    };
    const defaultSitePhone = isSite2537
        ? site?.Dados?.tel3 || site?.Dados?.tel1 || site?.Dados?.tel2
        : site?.Dados?.tel1 || site?.Dados?.tel2;
    const managerOrSitePhone = (managerActual?.id)
        ? (
            managerActual?.telefone ||
            managerActual?.telefone_2
        )
        : (
            defaultSitePhone
        );
    const whatsappVisitPhone = isSite2551 && hasAluguel ? '27998760688' : managerOrSitePhone;
    const whatsappVisitUrl = whatsParaImobiliaria(buildWhatsappUrl(
        `Olá, quero agendar uma visita ao imóvel Link: ${propertyUrl}`,
        whatsappVisitPhone
    ), site, managerActual?.id ? managerActual : null, 'I');
    const whatsappVisitUrl1859 = whatsParaImobiliaria(buildWhatsappUrl(
        `${site?.id == 1859 ? "Olá, estou acessando o imóvel no site e gostaria de mais informações:" : "Olá, quero agendar uma visita ao imóvel Link:"} ${propertyUrl}`,
        whatsappVisitPhone
    ), site, managerActual?.id ? managerActual : null, 'I');
    const whatsappProposalPhone = isSite2551 && hasAluguel ? '27998760688' : managerOrSitePhone;
    const whatsappProposalUrl = whatsParaImobiliaria(buildWhatsappUrl(
        `Olá, quero fazer uma proposta para o imóvel Link: ${propertyUrl}`,
        whatsappProposalPhone
    ), site, managerActual?.id ? managerActual : null, 'I');

    useEffect(() => {
        try {
            const getUser: any = localStorage.getItem('user');
            setExistUser(JSON.parse(getUser || ''));
        } catch (error) {}
    }, []);

    const buildMediaGallery = (photos: any[], includeBlocked = false) => {
        const items = [...photos];
        const hasVideo =
            detailsProperties?.link_video &&
            ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' &&
                detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") ||
                site?.id != '2059');
        const hasTour = Boolean(detailsProperties?.tour360);

        if (hasVideo && hasTour) {
            const video = detailsProperties?.link_video
                .replaceAll("https://www.youtube.com/watch?v=","")
                .replace("https://youtu.be/","")
                .split("&");

            if (Number(site?.id) === 2451 || isSite2507) {
                items.push(
                    { id: 'tour360', video: detailsProperties?.tour360 },
                    { id: 'video', video: video[0]?.split('/')?.slice(-1)[0] }
                );
            } else if (isSite2504) {
                items.push(
                    { id: 'video', video: video[0]?.split('/')?.slice(-1)[0] },
                    { id: 'tour360', video: detailsProperties?.tour360 }
                );
            } else {
                items.unshift(
                    { id: 'video', video: video[0]?.split('/')?.slice(-1)[0] },
                    { id: 'tour360', video: detailsProperties?.tour360 }
                );
            }
        } else if (hasVideo) {
            const video = detailsProperties?.link_video
                .replaceAll("https://www.youtube.com/watch?v=","")
                .replace("https://youtu.be/","")
                .split("&");

            if (Number(site?.id) === 2451 || isSite2504 || isSite2507) {
                items.push({ id: 'video', video: video[0]?.split('/')?.slice(-1)[0] });
            } else {
                items.unshift({ id: 'video', video: video[0]?.split('/')?.slice(-1)[0] });
            }
        } else if (hasTour) {
            if (isSite2504) {
                items.push({ id: 'tour360', video: detailsProperties?.tour360 });
            } else {
                items.unshift({ id: 'tour360', video: detailsProperties?.tour360 });
            }
        }

        if (includeBlocked) {
            const videoIndex = Number(site?.id) === 2451 || isSite2507
                ? items.findIndex((item: any) => item?.id === 'video')
                : -1;

            if (videoIndex >= 0) {
                items.splice(videoIndex, 0, { id: 'bloquear' });
            } else {
                items.push({ id: 'bloquear' });
            }
        }

        return items;
    };

    useEffect(() => {
        if (gallery?.length > 0 && site?.id && detailsProperties?.id) {
            const validationOrderGallery = gallery
            const validationGallery =
                existUser || verFts === "1" || verfts == '1' ||
                !shouldBlockPhotos
                    ? validationOrderGallery
                    : validationOrderGallery?.slice(
                          0,
                          site?.qtd_fotos_bloqueios
                      );
            if (
                existUser || verFts === "1" || verfts === '1' ||
                !shouldBlockPhotos
            ) {
                setOrderGallery(buildMediaGallery(validationGallery));
            } else {
                setOrderGallery(buildMediaGallery(validationGallery, true));
            }
        }
    }, [gallery, site, detailsProperties, existUser]);

    // methods
    const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setName(value);
    };

    // const openForm = () => {
    //     setActive(true);
    // };

    const onChangeTelephone = (value: string) => {
        setTelephone(value);
    };
    const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setEmail(value);
    };

    function isPhoneNumberValid(phoneNumber: string): boolean {
        // Remove todos os caracteres não numéricos
        const cleanedNumber = phoneNumber.replace(/\D/g, '');

        // Verifica se todos os caracteres são iguais
        const allEqual = new Set(cleanedNumber).size === 1;

        // Retorna true se não forem todos iguais
        return !allEqual;
    }

    const validaSendUser = async () => {
        if (name != '' && email != '' && telephone != '') {
            const phone = telephone.replace(/[^0-9]/g, '');
            const valida = isPhoneNumberValid(phone)
            var re = /\S+@\S+\.\S+/;
            if (phone.length > 9 && phone.length < 17 && (site?.internacional || phone.length < 12) && valida) {
                if (re.test(email) == true) {
                    if(acceptPolitic && !processando){
                        if(!processando){
                            setProcessando(true);
                            actionSendUser();
                        }
                    }else {
                        alert('Concorde com os termos de uso!');
                    }
                } else {
                    alert('Preencha um email válido!');
                }
            } else {
                alert('Preencha um número de telefone válido!');
            }
        } else {
            alert(
                'Preencha todos os campos do formulário para ver mais fotos!'
            );
        }
    };
    const actionSendUser = async () => {
        const getSendUser = await sendUser(
            site?.internacional ? true : false,
            JSON.stringify(utm_campaign),
            JSON.stringify(utm_source),
            JSON.stringify(utm_medium),
            JSON.stringify(utm_id),
            JSON.stringify("Solicitou ver mais fotos do imóvel " + detailsProperties?.id),
            JSON.stringify(name),
            JSON.stringify(email),
            JSON.stringify(telephone),
            detailsProperties?.id,
            agenciador != undefined ? Number(agenciador) : 0,
            origin,
            codsite,
            interesse ? interesse : ""
        );
        localStorage.setItem(
            'user',
            JSON.stringify({
                name,
                email,
                telephone,
                id_client: getSendUser?.atendimento?.id_cliente,
            })
        );
        const user = {
            name,
            telephone,
            email,
        };
        localStorage.setItem('user', JSON.stringify(user));
        setExistUser(user)
        // window.location.reload();
        if (!router.asPath.includes("enviar=1")) {
            const newUrl = router.asPath.includes("?")
                ? `${router.asPath}&enviar=1`
                : `${router.asPath}?enviar=1`;

            window.history.replaceState(null, '', newUrl);
        }
        setProcessando(false);

        if (site?.tag_google_head || site?.google_analytics_head) {
            // NÃO mande PII para GA/GTM:
            const gaParams = {
            source: "property",
            property_ref: detailsProperties?.referencia,
            property_id: detailsProperties?.id,
            listing_type: detailsProperties?.venda ? "venda" : (detailsProperties?.aluguel ? "aluguel" : "na"),
            city: detailsProperties?.cidade?.nome,
            neighborhood: detailsProperties?.bairro?.nome,
            price: detailsProperties?.preco ?? detailsProperties?.preco_loca ?? 0,
            currency: "BRL",
            // opcional: padronize com items[] (melhora análises)
            items: [{
                item_id: String(detailsProperties?.referencia ?? detailsProperties?.id),
                item_name: detailsProperties?.tipo?.nome ?? "Imóvel",
                item_category: "Imóveis",
                item_variant: detailsProperties?.bairro?.nome,
                price: detailsProperties?.preco ?? detailsProperties?.preco_loca ?? 0,
                currency: "BRL",
                item_brand: site?.Dados?.empresa,
                item_list_name: "property_page",
            }],
            };

            // Dispara para GTM/GA4
            trackEvent("generate_lead", gaParams);
            // GA4/GTM: evento EXCLUSIVO do formulário "Ver mais fotos" (#1389, cs2128) — separável no GTM do lead
            // da ficha do imóvel/blog, que seguem com `lead_submit_success`. Mesmo padrão do flutuante de WhatsApp (#1221).
            trackEvent("lead_submit_success_ver_fotos", gaParams);
        }

        if (getSendUser?.atendimento?.id_cliente) {
            const leadEventId = genMetaEventId();

            // Lead de BROWSER (Pixel) — dispara sempre que o lead foi salvo (no-op p/ tenant
            // sem pixel). Compartilha o eventId com o CAPI abaixo p/ dedup browser×CAPI.
            trackMetaEvent(site, 'Lead', {
                content_ids: [String(detailsProperties?.id)],
                content_type: 'product',
                content_name: detailsProperties?.titulo,
                lead_source: 'property_contact_form',
                ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
            }, { eventId: leadEventId });

            // Lead via CAPI (server-side /api/meta-capi): PII hasheada no CLIENTE; MESMO leadEventId
            // da perna browser → Meta dedupa. Token/pixel resolvidos por host no servidor.
            if (resolvePixelId(site?.fb_id_pixel, site?.pixel_facebook_head)) {
                const normalizedName = name.trim().toLowerCase();
                const normalizedEmail = email.trim().toLowerCase();
                const normalizedPhone = telephone.replace(/\D/g, ''); // Apenas números

                sendMetaCapiEvent({
                    site,
                    eventName: 'Lead',
                    eventId: leadEventId,
                    // ESPELHA os params não-PII da perna browser: com adblocker o /tr morre e só
                    // este endpoint first-party chega com value/conteúdo do Lead.
                    customData: {
                        content_ids: [String(detailsProperties?.id)],
                        content_type: 'product',
                        content_name: detailsProperties?.titulo,
                        lead_source: 'property_contact_form',
                        ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
                    },
                    userData: {
                        fn: [sha256(normalizedName)],
                        em: [sha256(normalizedEmail)],
                        ph: [sha256(normalizedPhone)],
                    },
                });
            }
        }
    };

    const handleProgress = (progress: number) => {
        if(openOption == 0 && !existUser && verFts != "1" && verfts != '1' && shouldBlockPhotos){
            if (progress >= 0.9) {
                setOpenOption(1);
            }
        }
    };

    return (
            <>
                <div className={styles.container_fora}>
                    <div className={styles.container0}>
                        <div>
                            <div style={{display: "flex"}}>
                                <div
                                    className={styles.codigoImovel}
                                >
                                    {`Código: ${detailsProperties?.referencia}`}
                                </div>
                                {detailsProperties?.exclu ?
                                    <div
                                        className={styles.imovel_exclusivo}
                                    >
                                        Imóvel Exclusivo
                                    </div>
                                : null}
                                {detailsProperties?.origem == "Orulo" && site?.id == 2196 ?
                                    <div className={styles.imovel_exclusivo}>
                                        <div>ESTUDA DAÇÃO</div>
                                    </div>
                                : null}
                                {detailsProperties?.visualizacoes ? (
                                    <div className={styles.subtitle_view}>
                                        {(detailsProperties?.visualizacoes > 99 || site?.id == "1694" || site?.id == "1665" ) && site?.mostrar_visualizacoes ?
                                            <>
                                                <div
                                                    className={styles.imovel_exclusivo} style={{padding: "0px 10px"}}
                                                >
                                                     <BsEyeFill
                                                        size={18}
                                                        color="#6ba94f"
                                                        style={{ marginRight: 5 }}
                                                    />
                                                   {detailsProperties?.visualizacoes + ' Visualizações'}
                                                </div>
                                            </>
                                        :null}
                                    </div>
                            ) : null}
                            </div>

                            {formatarDataEntrega(Number(detailsProperties?.data_entrega)) != "false" && detailsProperties?.data_entrega && site?.mostrar_data_entrega ?
                                <label className={styles.subtitle1} style={{margin: "5px 0px"}}>
                                    Entrega em {formatarDataEntrega(Number(detailsProperties?.data_entrega))}
                                </label>
                            : null}
                            {hasPropertyTitle && !site?.titulo_automatico ?
                                <h1 className={styles.adjust_font_size} style={estiloTitulo} data-gfm data-fs2>
                                    {propertyTitle}
                                </h1>
                                :
                                <h1 className={styles.adjust_font_size} style={estiloTitulo} data-gfm data-fs2>
                                    {detailsProperties?.tipo?.nome}{' '}
                                    {detailsProperties?.area_privativa > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_privativa)) +" m² privativos, " :
                                    detailsProperties?.area_total > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_total)) +" m² de área total, " :
                                    detailsProperties?.terreno > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.terreno)) +" "+ areaTipo + " de área terreno, " : ""}
                                    {formatAutomaticPropertyRooms(detailsProperties, site)}
                                    {"em "+detailsProperties?.cidade?.nome}
                                    {`${detailsProperties?.empreendimento?.nome && site?.exibir_empreendimento ? " - "+detailsProperties?.empreendimento?.nome : ''}`}
                                </h1>}
                            {canShowPropertyAddress(detailsProperties, site) ?
                                <label className={styles.subtitle1} style={{marginBottom: 20}}>
                                    {formatPropertyAddress(detailsProperties, site, { includeLocation: true })}
                                </label>
                            : null}
                        </div>

                        <div>
                            <div>
                                {detailsProperties?.venda ?
                                    Number(
                                        detailsProperties?.exibir_preco_venda &&
                                            detailsProperties?.preco_venda
                                    ) ? (
                                        <div
                                            data-gfm1
                                            className={detailsProperties?.preco_especial?.preco_especial_venda ? styles.text_price_oferta : styles.text_price}
                                        >
                                            {rotuloPreco('Venda', conversor ? 'Venda:' : `Venda: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo}`)}
                                            <label style={detailsProperties?.preco_especial?.preco_especial_venda ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                                {conversor ? <PrecoMoeda valor={detailsProperties?.preco_venda} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_venda, 2)}`} detalhe={!detailsProperties?.preco_especial?.preco_especial_venda} /> : `${toPrice(
                                                    detailsProperties?.preco_venda,
                                                    2
                                                )}`}
                                            </label>
                                        </div>
                                    ) : <label
                                            data-gfm1
                                            className={
                                                detailsProperties?.preco_especial
                                                    ?.preco_especial_venda
                                                    ? styles.text_price_oferta
                                                    : styles.text_price
                                            }
                                        >
                                            {precoRotulado ? <><span className={styles.rotulo_preco}>Venda</span>Valor sob Consulta</> : `Venda: Valor sob Consulta`}
                                        </label> : null}
                                {detailsProperties?.venda ?
                                    detailsProperties?.preco_especial?.preco_especial_venda &&
                                        detailsProperties?.exibir_preco_venda &&
                                        detailsProperties?.preco_venda ? (
                                        <label className={styles.text_price}>
                                            {conversor ? <>{'Por: '}<PrecoMoeda valor={detailsProperties?.preco_especial?.preco_especial_venda} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_especial?.preco_especial_venda, 2)}`} detalhe /></> : `Por: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                                detailsProperties?.preco_especial
                                                    ?.preco_especial_venda,
                                                2
                                            )}`}
                                        </label>
                                    ) : null
                                    :null
                                }
                            </div>

                            <div>
                                {Number(
                                    detailsProperties?.aluguel &&
                                        detailsProperties?.exibir_preco_locacao &&
                                        detailsProperties?.preco_locacao
                                ) ? (
                                    <div
                                        className={
                                            detailsProperties?.preco_especial
                                                ?.preco_especial_locacao
                                                ? styles.text_price_oferta
                                                : styles.text_price
                                        }
                                    >
                                        {rotuloPreco('Aluguel', conversor ? 'Aluguel:' : `Aluguel: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo}`)}
                                            <label style={detailsProperties?.preco_especial?.preco_especial_locacao ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                                {conversor ? <PrecoMoeda valor={detailsProperties?.preco_locacao} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_locacao, 2)}`} detalhe={!detailsProperties?.preco_especial?.preco_especial_locacao} /> : `${toPrice(
                                                    detailsProperties?.preco_locacao,
                                                    2
                                                )}`}
                                            </label>
                                    </div>
                                ) : null}

                                {detailsProperties?.aluguel &&
                                detailsProperties?.preco_especial
                                    ?.preco_especial_locacao &&
                                detailsProperties?.exibir_preco_locacao &&
                                detailsProperties?.preco_locacao ? (
                                    <label className={styles.text_price}>
                                        {conversor ? <>{'Por: '}<PrecoMoeda valor={detailsProperties?.preco_especial?.preco_especial_locacao} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_especial?.preco_especial_locacao, 2)}`} detalhe /></> : `Por: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                            detailsProperties?.preco_especial
                                                ?.preco_especial_locacao,
                                            2
                                        )}`}
                                    </label>
                                ) : null}
                            </div>

                            { detailsProperties?.temporada && detailsProperties?.d1 > 0
                                ? (
                                    <label
                                        className={
                                            styles.text_price
                                        }
                                        style={{marginTop: 20}}
                                    >
                                        {site?.id != '1667' ?
                                            <>
                                        {conversor ? <>{'Diária: '}<PrecoMoeda valor={detailsProperties?.d1} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.d1, 2)}`} /></> : `Diária: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                            detailsProperties?.d1,
                                            2
                                        )}`}
                                        </>
                                        : <>Diária: Sob Consulta</>}
                                    </label>
                            ) :
                                <>
                                    {site?.id == 2451 && detailsProperties?.aluguel && !Number(detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) ? (
                                        <label className={styles.text_price_oferta1}>Aluguel: Sob Consulta</label>
                                    ) : null}
                                    {detailsProperties?.exibir_preco_iptu &&
                                        detailsProperties?.preco_iptu > 0 ? (
                                            <label className={styles.text_price_oferta1}>{conversor ? <>{'IPTU: '}<PrecoMoeda valor={detailsProperties?.preco_iptu} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_iptu, 2)}`} /></> : `IPTU: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                                detailsProperties?.preco_iptu,
                                                2
                                            )}`}</label>
                                        ) : null}
                                        {detailsProperties?.exibir_preco_condominio &&
                                        detailsProperties?.preco_condominio > 0 ? (
                                            <label className={styles.text_price_oferta1}>{conversor ? <>{`CONDOMÍNIO: ${site2551CondominioPrefix}`}<PrecoMoeda valor={detailsProperties?.preco_condominio} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_condominio, 2)}`} />{site2551CondominioAddendum}</> : `CONDOMÍNIO: ${site2551CondominioPrefix}${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                                detailsProperties?.preco_condominio,
                                                2
                                            )}${site2551CondominioAddendum}`}</label>
                                        ) : null
                                    }
                                    {detailsProperties?.aluguel && (detailsProperties?.preco_especial?.preco_especial_locacao > 0 || detailsProperties?.preco_locacao > 0) && site?.id == 747 && (detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) && ((detailsProperties?.exibir_preco_condominio && detailsProperties?.preco_condominio) || (detailsProperties?.exibir_preco_iptu && detailsProperties?.preco_iptu > 0)) ?
                                        <label className={styles.text_price_oferta1} style={{fontWeight: 'bold', fontSize: 24}}>
                                            {`Total: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(calcularTotal(
                                                detailsProperties?.preco_especial?.preco_especial_locacao ? Number(detailsProperties?.preco_especial?.preco_especial_locacao) : Number(detailsProperties?.preco_locacao),
                                                detailsProperties?.exibir_preco_condominio ? Number(detailsProperties?.preco_condominio) || 0 : 0,
                                                detailsProperties?.exibir_preco_iptu ? Number(detailsProperties?.preco_iptu) || 0 : 0
                                            ),2)}`}
                                        </label>
                                        : null
                                    }
                                </>
                            }
                            <div className={styles.botoes_captacao}>
                            {site?.id == 1859 ?
                            <a
                                href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl1859}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                    trackMetaEvent(site, 'Contact', {
                                        content_ids: [String(detailsProperties?.id)],
                                        content_type: 'product',
                                        content_name: detailsProperties?.titulo,
                                        contact_method: 'schedule_visit',
                                        ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
                                    });

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl1859,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                                rel="noopener noreferrer"
                                className={styles.botao_visita}
                                title="Agendar uma visita para este imóvel via WhatsApp"
                                aria-label="Agendar uma visita para este imóvel via WhatsApp"
                            >
                                Saiba Mais
                            </a>: null}
                                <a
                                    rel="noopener noreferrer"
                                    href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                        trackMetaEvent(site, 'Contact', {
                                            content_ids: [String(detailsProperties?.id)],
                                            content_type: 'product',
                                            content_name: detailsProperties?.titulo,
                                            contact_method: 'schedule_visit',
                                            ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
                                        });

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    className={site?.id == 1859 ? styles.botao_proposta : styles.botao_visita}
                                    title="Agendar uma visita para este imóvel via WhatsApp"
                                    aria-label="Agendar uma visita para este imóvel via WhatsApp"
                                >
                                    {site?.id == 2374 ? 'Chamar no WhatsApp' : 'Agendar Visita'}
                                </a>
                                {site?.id != 1859 && site?.id != 2451 ?
                                <a
                                    rel="noopener noreferrer"
                                    href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappProposalUrl}
                                    onClick={async (e) => {
                                        e.preventDefault(); // Evita o redirecionamento automático

                                        trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                        trackMetaEvent(site, 'Contact', {
                                            content_ids: [String(detailsProperties?.id)],
                                            content_type: 'product',
                                            content_name: detailsProperties?.titulo,
                                            contact_method: 'make_offer',
                                            ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
                                        });

                                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                        setTimeout(() => {
                                        window.open(
                                            site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappProposalUrl,
                                            "_blank"
                                        );
                                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                    }}
                                    title="Agendar uma visita para este imóvel via WhatsApp"
                                    aria-label="Agendar uma visita para este imóvel via WhatsApp"
                                    className={styles.botao_proposta}
                                >
                                    {site?.id == 2374 ? 'FALE COM O CORRETOR' : 'Fazer Proposta'}
                                </a>: null}
                            </div>
                        </div>
                    </div>
                    <div className={styles.container}>
                        <div className={styles.div_baloes1}>
                            <Compartilhar favorito={favorito} detailsProperties={detailsProperties}></Compartilhar>
                        </div>
                        <div className={styles.div_baloes}>
                            <Botoes
                                setOpenOption={setOpenOption}
                                site={site}
                                detailsProperties={detailsProperties}
                                setOpenMapa={setOpenMapa}
                                setOpenStreet={setOpenStreet}
                                openOption={openOption}
                                favorito={favorito}
                                setFavorito={setFavorito}
                            />
                        </div>
                        <Swiper
                            modules={[Navigation]}
                            slidesPerView="auto"
                            slidesPerGroup={1}
                            spaceBetween={10}
                            freeMode={true}
                            navigation={true}
                            className={styles.mySwiper}
                            style={stylo}
                            onProgress={(swiper: any) => handleProgress(swiper.progress)}
                        >
                        {orderGallery?.map((v: any, i: number) => {
                            const photoSrc = getWatermarkImageSrc(v?.url_foto, site);
                            const photoRetrySrc = getWatermarkImageSrc(v?.url_foto_menor, site);
                            const photoIndex = orderGallery.slice(0, i + 1).filter((item: any) => item?.url_foto).length - 1;
                            const isPriorityPhoto = photoIndex >= 0 && photoIndex < 2;
                            const activeAnimationPhoto = () => {
                                setAnimationPhoto(Number(v?.id));
                            };
                            if (
                                !existUser &&
                                v?.id === 'bloquear' && verFts != "1" && verfts != '1' && shouldBlockPhotos
                            )  {
                                return (
                                    <SwiperSlide key="carrossel" style={{maxWidth: '100%',width: '650px'}}>
                                        <div
                                            className={styles.container_form}
                                            key={'block'+v?.id}
                                            // onMouseEnter={openForm}
                                        >
                                            {/* {active ? ( */}
                                            <div className={styles.form}>
                                                {site?.id == 1630 ?
                                                    <label className={styles.title}>
                                                        Ver mais fotos
                                                    </label>
                                                :
                                                    <>
                                                    <label className={styles.title}>
                                                        Acesso completo
                                                    </label>
                                                    <div className={styles.subtitle}>
                                                        <p
                                                            className={styles.subtitle_time}
                                                            style={modeloNovo ? undefined : { color: "#c5c5c5" }}
                                                        >
                                                            a todo o site em 10 segundos!
                                                        </p>
                                                    </div>
                                                    </>
                                                }
                                                <input
                                                    className={styles.input}
                                                    placeholder="Nome"
                                                    value={name}
                                                    onChange={onChangeName}
                                                />
                                                <AppPhoneInput
                                                    id="Telefone_id"
                                                    value={telephone}
                                                    onChange={onChangeTelephone}
                                                    placeholder="Telefone"
                                                    defaultCountry="BR"
                                                    width_max={modeloNovo ? undefined : 70}
                                                    inputHeight={56}
                                                    limitMaxLength={true}
                                                    inputClassName={styles.input}
                                                    semPais={!site?.internacional ? true : false}
                                                    includeCountryCode={site?.internacional ? true : false}
                                                />
                                                <input
                                                    className={styles.input}
                                                    placeholder="Email"
                                                    value={email}
                                                    onChange={onChangeEmail}
                                                />
                                                {detailsProperties.aluguel && detailsProperties.venda ?
                                                    <>
                                                        <label className={styles.title_form_one1}>
                                                            SELECIONE SEU INTERESSE:
                                                        </label>
                                                        <ButtonGroup disableElevation variant="contained" color="primary" style={{marginBottom: "15px"}}>
                                                            <Button onClick={selectTransacao} style={interesse == "Venda" ? site?.cor2 == "#ffffff" ? { backgroundColor: "gray", border: "1px solid gray"} : { backgroundColor: site?.cor2, border: "1px solid gray"} : { backgroundColor: "white", color: "#3d3d3d", border: "1px solid #3d3d3d" }}>Venda</Button>
                                                            <Button onClick={selectTransacao} style={interesse == "Aluguel" ? site?.cor2 == "#ffffff" ? { backgroundColor: "gray", border: "1px solid gray"} : { backgroundColor: site?.cor2, border: "1px solid gray"} : { backgroundColor: "white", color: "#3d3d3d", border: "1px solid #3d3d3d" }}>Aluguel</Button>
                                                        </ButtonGroup>
                                                    </>
                                                : null}
                                                <div className={styles.adjust_checkbox}>
                                                <Checkbox
                                                    style={{ color: modeloNovo ? 'inherit' : 'rgb(126, 126, 126)' }}
                                                    checked={acceptPolitic}
                                                    onChange={(event, value) => setAcceptPolitic(value)}
                                                />
                                                <div className={styles.description_form}>
                                                    Ao enviar concordo com os
                                                    <Link prefetch={false} href="/termos">
                                                        <label className={styles.terms}>
                                                            termos de uso
                                                        </label>
                                                    </Link>
                                                    e
                                                    <Link prefetch={false} href="/politica">
                                                        <label className={styles.terms}>
                                                            política de privacidade,
                                                        </label>
                                                    </Link>
                                                    {finalidadeAceiteForm(site)} e afirmo ter mais
                                                    de 18 anos
                                                </div>
                                            </div>
                                                <a
                                                    className={
                                                        acceptPolitic && name != '' && email != '' && !processando && telephone != '' && telephone.length > 10 && telephone.length < 16 && /\S+@\S+\.\S+/.test(email) == true
                                                            ? styles.button_more_photo
                                                            : styles.action_more_disabled
                                                    }
                                                    onClick={validaSendUser}
                                                >
                                                {detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059') ? site?.id == 1630 ? 'Acessar Agora' : 'Ver fotos' : site?.id == 1630 ? 'Acessar Agora' : 'Ver fotos'}
                                                </a>
                                            </div>
                                            {/* ) : (
                                                <label className={styles.welcome}>
                                                    Carregar + fotos
                                                </label>
                                            )} */}
                                        </div>
                                    </SwiperSlide>
                                );
                            }

                            if (v?.id === 'video' && detailsProperties?.link_video && ((detailsProperties?.link_video != 'https://youtu.be/EngkU-Vcp2Q' && detailsProperties?.link_video != "https://www.youtube.com/watch?v=EngkU-Vcp2Q&feature=youtu.be") || site?.id != '2059')) {
                                const getFirstPhoto = orderGallery?.find(
                                    (e: any) => e?.url_foto
                                );

                                return (
                                    <SwiperSlide key="carrossel1" style={{ maxWidth: '100%', width: '650px' }}>
                                        <div
                                            onClick={() => setOpenOption(3)}
                                            key={'galeria'+v?.id}
                                            className={styles.container_img}
                                        >
                                            <WatermarkFallbackImage
                                                src={getWatermarkImageSrc(getFirstPhoto?.url_foto, site)}
                                                retrySrc={getWatermarkImageSrc(getFirstPhoto?.url_foto_menor, site)}
                                                fallbackSrc={getFirstPhoto?.url_foto}
                                                alt={`Vídeo do imóvel ${detailsProperties?.titulo}`}
                                                className={styles.img}
                                                fill
                                                sizes="(max-width: 768px) 100vw, 650px"
                                                unoptimized
                                            />
                                            <div className={styles.background_animation1}>
                                                <FaPlay size={100} color="white" />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            } else {
                                if(v?.id === 'tour360'){
                                    if(v?.video.includes("youtu")){
                                        const video = v?.video.replaceAll("https://www.youtube.com/watch?v=","").replace("https://youtu.be/","").split("?")[0];
                                        const urlThumbnail = `https://img.youtube.com/vi/${video}/maxresdefault.jpg`; // URL da thumbnail

                                        return (
                                            <SwiperSlide key="carrossel2" style={{ maxWidth: '100%', width: '650px' }}>
                                                <div
                                                    onClick={() => setOpenOption(4)}
                                                    key={'tour' + v?.id}
                                                    className={styles.container_img}
                                                >
                                                    <Image
                                                        src={urlThumbnail} // Exibe a thumbnail do vídeo
                                                        alt={`Tour virtual do imóvel ${detailsProperties?.titulo}`}
                                                        className={styles.img}
                                                        fill
                                                        sizes="(max-width: 768px) 100vw, 650px"
                                                        unoptimized
                                                    />
                                                    <div className={styles.background_animation1}>
                                                        <Md360 size={100} color="white" />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    }

                                    return (
                                        <SwiperSlide key="carrossel3" style={{maxWidth: '100%',width: '650px'}}>
                                            <div
                                                onClick={() => setOpenOption(4)}
                                                key={'tour'+v?.id}
                                                className={styles.container_img}
                                            >
                                                <iframe className={styles.img} id="tour-360" src={v?.video}></iframe>
                                                <div className={styles.background_animation1}>
                                                    <Md360 size={100} color="white" />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                }
                            }
                            return v?.url_foto ? (
                                <SwiperSlide key={v?.id} style={{maxWidth: '100%',width: '650px'}}>
                                    <div
                                        onMouseEnter={activeAnimationPhoto}
                                        onClick={() => setOpenOption(1)}
                                        key={'close'+v?.id}
                                        className={styles.container_img}
                                    >
                                        <WatermarkFallbackImage
                                            src={photoSrc}
                                            retrySrc={photoRetrySrc}
                                            fallbackSrc={v?.url_foto}
                                            className={styles.img}
                                            alt={`Foto do imóvel - ${detailsProperties?.titulo}`}
                                            fill
                                            sizes="(max-width: 768px) 100vw, 650px"
                                            {...(isPriorityPhoto ? { priority: true } : {})}
                                            unoptimized
                                        />
                                        {animationPhoto === Number(v?.id) ? (
                                            <div className={styles.background_animation}></div>
                                        ) : null}
                                        {/* topo: nesta galeria a fileira de balões ocupa a BASE da capa */}
                                        {decoradorAtivo && decoradorV2 && photoIndex === 0 ? <DecorarHeroButton posicao="topo" cor2={site?.cor2} /> : null}
                                        {decoradorAtivo && decoradorV2 && isFotoDecorada(v) ? (
                                            <DecorarBadge foto={v} fotos={detailsProperties?.fotos} onLightbox={() => setOpenOption(1)} />
                                        ) : null}
                                        {decoradorAtivo && !(decoradorV2 && photoIndex === 0) && podeDecorarFoto(v, detailsProperties) ? <DecorarPhotoPill fotoUrl={v?.url_foto} /> : null}
                                    </div>
                                </SwiperSlide>
                            ) : null;
                        })}
                    </Swiper>
                </div>
                <div className={styles.container00}>
                    <div
                        className={styles.codigoImovel} style={site?.id == 2379 ? {display: "none"} : {}}
                    >
                        {`Código: ${detailsProperties?.referencia}`}
                    </div>
                    {detailsProperties?.exclu ?
                        <div
                            className={styles.imovel_exclusivo}
                            style={{ marginLeft: 0, marginTop: 8 }}
                        >
                            Imóvel Exclusivo
                        </div>
                    : null}
                    {/* H1 único (INC-0283): o título do bloco mobile é <h2> com a MESMA classe — o <h1> fica só no bloco
                        desktop (os dois alternam por CSS; .adjust_font_size fixa fonte/peso/margem, a tag não muda o desenho). */}
                    {hasPropertyTitle && !site?.titulo_automatico ?
                        <h2 className={styles.adjust_font_size} style={estiloTitulo} data-gfm>
                            {propertyTitle}
                        </h2>
                        :
                        <h2 className={styles.adjust_font_size} style={estiloTitulo} data-gfm>
                            {detailsProperties?.tipo?.nome}{' '}
                            {detailsProperties?.area_privativa > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_privativa)) +" m² privativos, " :
                            detailsProperties?.area_total > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.area_total)) +" m² de área total, " :
                            detailsProperties?.terreno > 0 ? " com "+NumeroFormatado(Number(detailsProperties?.terreno)) +" "+ areaTipo + " de área terreno, " : null}
                            {formatAutomaticPropertyRooms(detailsProperties, site)}
                            {"em "+detailsProperties?.cidade?.nome}
                            {`${detailsProperties?.empreendimento?.nome && site?.exibir_empreendimento ? " - "+detailsProperties?.empreendimento?.nome : ''}`}
                        </h2>}
                    {canShowPropertyAddress(detailsProperties, site) ?
                        <label className={styles.subtitle1} style={{marginBottom: 20}}>
                            {formatPropertyAddress(detailsProperties, site, { includeLocation: true })}
                        </label>
                    : null}

                    <div>
                        {detailsProperties?.venda ?
                            Number(
                                detailsProperties?.exibir_preco_venda &&
                                    detailsProperties?.preco_venda
                            ) ? (
                                <div
                                    data-gfm1
                                    className={detailsProperties?.preco_especial?.preco_especial_venda ? styles.text_price_oferta : styles.text_price}
                                >
                                    {rotuloPreco('Venda', conversor ? 'Venda:' : `Venda: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo}`)}
                                    <label style={detailsProperties?.preco_especial?.preco_especial_venda ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                        {conversor ? <PrecoMoeda valor={detailsProperties?.preco_venda} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_venda, 2)}`} detalhe={!detailsProperties?.preco_especial?.preco_especial_venda} /> : `${toPrice(
                                            detailsProperties?.preco_venda,
                                            2
                                        )}`}
                                    </label>
                                </div>
                            ) : <label
                                    data-gfm1
                                    className={
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda
                                            ? styles.text_price_oferta
                                            : styles.text_price
                                    }
                                >
                                    {precoRotulado ? <><span className={styles.rotulo_preco}>Venda</span>Valor sob Consulta</> : `Venda: Valor sob Consulta`}
                                </label> : null}
                        {detailsProperties?.venda ?
                            detailsProperties?.preco_especial?.preco_especial_venda &&
                                detailsProperties?.exibir_preco_venda &&
                                detailsProperties?.preco_venda ? (
                                <label className={styles.text_price}>
                                    {conversor ? <>{'Por: '}<PrecoMoeda valor={detailsProperties?.preco_especial?.preco_especial_venda} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_especial?.preco_especial_venda, 2)}`} detalhe /></> : `Por: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda,
                                        2
                                    )}`}
                                </label>
                            ) : null
                            :null
                        }
                    </div>

                    <div>
                        {Number(
                            detailsProperties?.aluguel &&
                                detailsProperties?.exibir_preco_locacao &&
                                detailsProperties?.preco_locacao
                        ) ? (
                            <div
                                className={
                                    detailsProperties?.preco_especial
                                        ?.preco_especial_locacao
                                        ? styles.text_price_oferta
                                        : styles.text_price
                                }
                            >
                                {rotuloPreco('Aluguel', conversor ? 'Aluguel:' : `Aluguel: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo}`)}
                                    <label style={detailsProperties?.preco_especial?.preco_especial_locacao ? {textDecoration: "line-through",marginLeft: 5} : {marginLeft: 5}}>
                                        {conversor ? <PrecoMoeda valor={detailsProperties?.preco_locacao} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_locacao, 2)}`} detalhe={!detailsProperties?.preco_especial?.preco_especial_locacao} /> : `${toPrice(
                                            detailsProperties?.preco_locacao,
                                            2
                                        )}`}
                                    </label>
                            </div>
                        ) : null}

                        {detailsProperties?.aluguel &&
                        detailsProperties?.preco_especial
                            ?.preco_especial_locacao &&
                        detailsProperties?.exibir_preco_locacao &&
                        detailsProperties?.preco_locacao ? (
                            <label className={styles.text_price}>
                                {conversor ? <>{'Por: '}<PrecoMoeda valor={detailsProperties?.preco_especial?.preco_especial_locacao} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_especial?.preco_especial_locacao, 2)}`} detalhe /></> : `Por: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                    detailsProperties?.preco_especial
                                        ?.preco_especial_locacao,
                                    2
                                )}`}
                            </label>
                        ) : null}
                    </div>

                    { detailsProperties?.temporada && detailsProperties?.d1 > 0
                        ? (
                            <label
                                className={
                                    styles.text_price
                                }
                                style={{marginTop: 20}}
                            >
                                {site?.id != '1667' ?
                                    <>
                                {conversor ? <>{'Diária: '}<PrecoMoeda valor={detailsProperties?.d1} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.d1, 2)}`} /></> : `Diária: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                    detailsProperties?.d1,
                                    2
                                )}`}
                                </>
                                : <>Diária: Sob Consulta</>}
                            </label>
                    ) :
                        <>
                            {site?.id == 2451 && detailsProperties?.aluguel && !Number(detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) ? (
                                <label className={styles.text_price_oferta1}>Aluguel: Sob Consulta</label>
                            ) : null}
                            {detailsProperties?.exibir_preco_iptu &&
                                detailsProperties?.preco_iptu > 0 ? (
                                    <label className={styles.text_price_oferta1}>{conversor ? <>{'IPTU: '}<PrecoMoeda valor={detailsProperties?.preco_iptu} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_iptu, 2)}`} /></> : `IPTU: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_iptu,
                                        2
                                    )}`}</label>
                                ) : null}
                                {detailsProperties?.exibir_preco_condominio &&
                                detailsProperties?.preco_condominio > 0 ? (
                                    <label className={styles.text_price_oferta1}>{conversor ? <>{`CONDOMÍNIO: ${site2551CondominioPrefix}`}<PrecoMoeda valor={detailsProperties?.preco_condominio} simbolo={simboloImovel} original={`${simboloImovel} ${toPrice(detailsProperties?.preco_condominio, 2)}`} />{site2551CondominioAddendum}</> : `CONDOMÍNIO: ${site2551CondominioPrefix}${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(
                                        detailsProperties?.preco_condominio,
                                        2
                                    )}${site2551CondominioAddendum}`}</label>
                                ) : null
                            }
                            {detailsProperties?.aluguel && (detailsProperties?.preco_especial?.preco_especial_locacao > 0 || detailsProperties?.preco_locacao > 0) && site?.id == 747 && (detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) && ((detailsProperties?.exibir_preco_condominio && detailsProperties?.preco_condominio) || (detailsProperties?.exibir_preco_iptu && detailsProperties?.preco_iptu > 0)) ?
                                <label className={styles.text_price_oferta1} style={{fontWeight: 'bold', fontSize: 24}}>
                                    {`Total: ${detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo} ${toPrice(calcularTotal(
                                        detailsProperties?.preco_especial?.preco_especial_locacao ? Number(detailsProperties?.preco_especial?.preco_especial_locacao) : Number(detailsProperties?.preco_locacao),
                                        detailsProperties?.exibir_preco_condominio ? Number(detailsProperties?.preco_condominio) || 0 : 0,
                                        detailsProperties?.exibir_preco_iptu ? Number(detailsProperties?.preco_iptu) || 0 : 0
                                    ),2)}`}
                                </label>
                                : null
                            }
                        </>
                    }
                </div>
            </div>
            {modeloNovo ? (
                <div className={styles.migalhas}>
                    <HistoryComponent site={site} routes={initialFlow} pagina={3} rotulos={rotulosHistorico}/>
                </div>
            ) : (
                <HistoryComponent site={site} routes={initialFlow} pagina={3} rotulos={rotulosHistorico}/>
            )}
        </>
    );
};

export default GalleryPiecesProperties3;

export const getServerSideProps = async () => ({ notFound: true });
